<template>
  <div
    class="monitor"
    style="font-size: 16px; width: 100%; background: #eff1f5"
  >
    <div class="content">
      <div class="yuliang" ref="yuliang" style="margin-top: 0">
        <div class="select clearfix" ref="districtrainOperation">
          <span class="desc">时间:</span>
          <div style="display: inline-block">
            <el-date-picker
              v-model='query.begTime'
              value-format="yyyy-MM-dd HH:00"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择开始时间"
              :clearable="false"
              :editable="false"
               default-time="8:00:00"
            ></el-date-picker>
          </div>
         <span id="select" @click="searchData">查询</span>
          <span id="export" @click="exportDocx">
            <span class="export-icon" ref="downloadArea"></span>导出
          </span>
        </div>
        <div class="tableDiv" ref="tableDiv" v-loading = "loading">
          <div class='tinymce' style="width:100%;height:100%">
          <editor id='tinymce' v-model='tinymceHtml' :init="init"></editor>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import htmlDocx from 'html-docx-js/dist/html-docx' // html转word
import saveAs from 'file-saver'
import tinymce from 'tinymce/tinymce.min.js'
// import 'tinymce/themes/silver/theme'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver'
import 'tinymce/plugins/image'
import 'tinymce/plugins/link'
import 'tinymce/plugins/code'
import 'tinymce/plugins/table'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/contextmenu'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/colorpicker'
import 'tinymce/plugins/textcolor'
import 'tinymce/plugins/print'
import 'tinymce/icons/default/icons'
import reportAnalysisTypes from '@/store/types/reportAnalysis'
export default {
  name: 'tinymce',
  data () {
    return {
      loading: true,
      query: {
        addvcd: '330324',
        begTime: ''
      },
      queryTime: '',
      currentYear: '',
      tinymceHeight: 700,
      tdata: [],
      tinymceHtml: '', // 富文本内容
      showTrData: '',
      tableFrame: '',
      showTime: '',
      titleTime: '',
      nextText: [], // 下一步措施
      nextTextFrame: '',
      rainInfo: [], // 降雨情况
      rainInfoFrame: '',
      riverInfo: [], // 江河水情
      riverInfoFrame: '',
      reservoirInfo: '', // 水库水情
      reservoirInfoFrame: '',
      reservoirList: '', // 水库列表
      reservoirListFrame: '',
      townList: [], // 各乡镇列表
      townListFrame11: '', // 各镇降雨量表格前10个数据
      townListFrame12: '',
      townListFrame13: '',
      townListFrame21: '', // 各镇降雨量表格前10-20个数据
      townListFrame22: '',
      townListFrame23: '',
      townListFrame31: '', // 各镇降雨量之后数据
      townListFrame32: '',
      townListFrame33: '',
      init: {
        selector: '.tinymce',
        language_url: 'tinymce/zh_CN.js',
        language: 'zh_CN',
        skin_url: 'tinymce/skins/ui/oxide', // 皮肤引入错误可能不显示
        content_css: 'tinymce/water_rain_daily.css', // 内联模式引入css
        auto_focus: false,
        height: '100%',
        plugins: 'print link lists image code table colorpicker textcolor wordcount contextmenu',
        toolbar:
          'print bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist | outdent indent blockquote | undo redo | link unlink image code | removeformat',
        branding: false,
        inline: false
        // menubar: false
      }
    }
  },
  components: {
    Editor
  },
  methods: {
    getCurrentTime () { // 获取当前时间
      let nowdate = new Date()
      let year = nowdate.getFullYear()
      let mon = nowdate.getMonth() + 1
      let dd = nowdate.getDate()
      let hh = nowdate.getHours()
      // let mm = nowdate.getMinutes()
      if (hh >= 8) { // 当天8时以后，默认当天8时时间
        var timeAfter8 =
            year +
            '-' +
            (mon > 9 ? mon : '0' + mon) +
            '-' +
            (dd > 9 ? dd : '0' + dd) +
            ' ' +
            ('08:00')
        this.query.begTime = timeAfter8
      } else { // 当天8时之前，默认前一天8时时间
        var timebefore8 =
          year +
          '-' +
          (mon > 9 ? mon : '0' + mon) +
          '-' +
          ((dd - 1) > 9 ? (dd - 1) : ('0' + dd - 1)) +
          ' ' +
          ('08:00')
        this.query.begTime = timebefore8
      }
      this.queryTime = (this.query.begTime.slice(5, 7)) + '月' + this.query.begTime.slice(8, 10) + '日' + this.query.begTime.slice(10)
    },
    getChangeTime () { // 获取改变之后的时间
      this.queryTime = (this.query.begTime.slice(5, 7)) + '月' + this.query.begTime.slice(8, 10) + '日' + this.query.begTime.slice(10)
      let myDate = new Date()
      this.titleTime = myDate.getFullYear() + '年' + (myDate.getMonth() + 1) + '月' + myDate.getDate() + '日'
      this.showTime = (myDate.getMonth() + 1) + '月' + myDate.getDate() + '日' + myDate.getHours() + ':' + (myDate.getMinutes() > 9 ? myDate.getMinutes() : '0' + myDate.getMinutes())
    },
    searchData () {
      // 查询后拼接字符串覆盖为空
      this.nextTextFrame = ''
      this.rainInfoFrame = ''
      this.townListFrame11 = ''
      this.townListFrame12 = ''
      this.townListFrame13 = ''
      this.townListFrame21 = ''
      this.townListFrame22 = ''
      this.townListFrame23 = ''
      this.townListFrame31 = ''
      this.townListFrame32 = ''
      this.townListFrame33 = ''
      this.reservoirInfoFrame = ''
      this.reservoirListFrame = ''
      this.tabledata()
      this.getChangeTime()
    },
    getShowDataTr () { // 富文本内页面拼接
      this.tinymceHtml = ` 
      <p style="margin: 12px auto 0; display: block; text-align: center; font-weight: bold; font-size: 24pt; color: #f60;">永嘉县汛情通报</p>
      <p style="margin: 10px auto 0; display: block; text-align: center; font-size: 18pt; font-weight: bold;">(${this.currentYear}年第xx期)</p>
      <p style="border-bottom: 2px solid #f60; padding-bottom: 7px;"><span style="margin-left: 14pt; font-size: 14pt; font-weight: 500; color: #f60;">永嘉县水利局</span><span style="float: right; margin-right: 14pt; font-size: 14pt; font-weight: 500; color: #333;">${this.titleTime}</span></p>
      <p style="padding: 8px; font-size: 16pt; font-weight: bold; margin-top: 30px;">1.降雨情况</p>
      <p style="font-size: 14pt; margin-top: -5px; text-indent: 25px;">${this.rainInfo}</p>
      <p style="line-height: 30px; text-align: center; font-size: 16pt; font-weight: 500; height: 30px;">各镇(街道)降雨量</p>
      <p style="height: 15px; margin-top: -20px;"><span style="margin: 10px; font-size: 14pt; float: left;"><span>${this.queryTime}</span>至<span></span>${this.showTime}</span><span style="float: right; margin: 10px; font-size: 14pt;">单位:mm</span></p>
       <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
      <tbody class="tb1">
      <tr class="firstRow" style="background: #b0c0d5;">
      <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">镇(街道)</td>
      ${this.townListFrame11}
      </tr>
      <tr style="background: white;">
        <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">面雨量</td>
      ${this.townListFrame12}
      </tr>
      <tr style="background: white;">
      <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">最大雨量</td>
     ${this.townListFrame13}
     </tr>
      </tbody>
      </table>
       <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
      <tbody class="tb1">
      <tr class="firstRow" style="background: #b0c0d5;">
      <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">镇(街道)</td>
      ${this.townListFrame21}
      </tr>
      <tr style="background: white;">
        <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">面雨量</td>
      ${this.townListFrame22}
      </tr>
      <tr style="background: white;">
      <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">最大雨量</td>
     ${this.townListFrame23}
     </tr>
      </tbody>
      </table>
       <table style="width: 70.5%; border-collapse: collapse; margin-top: 10px;">
      <tbody class="tb1">
      <tr class="firstRow" style="background: #b0c0d5;">
      <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">镇(街道)</td>
      ${this.townListFrame31}
      </tr>
      <tr style="background: white;">
        <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">面雨量</td>
      ${this.townListFrame32}
      </tr>
      <tr style="background: white;">
      <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">最大雨量</td>
      ${this.townListFrame33}
      </tr>
      </tbody>
      </table>
      <p style="padding: 8px; font-size: 16pt; font-weight: 500; margin-top: 30px;">2.江河水情</p>
      <p style="font-size: 14pt; margin-top: -5px; text-indent: 25px;">${this.riverInfo}</p>
      <p style="padding: 8px; font-size: 16pt; font-weight: 500; margin-top: 30px;">3.水库水情</p>
      ${this.reservoirInfoFrame}
      <p style="line-height: 30px; text-align: center; font-size: 16pt; font-weight: 500; height: 30px;">全县水库蓄水情况表</p>
      <p style="height: 30px; margin-top: -20px;"><span style="float: right; margin: 10px; font-size: 14pt;">单位:万m&sup3;</span></p>
      <table style="margin-bottom: 30px; width: 100%; border-collapse: collapse;">
      <tbody class="tb3">
      <tr class="firstRow" style="background: #b0c0d5;">
      <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;" colspan="1" rowspan="2">水情指标</td>
      <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;" colspan="4" rowspan="1">总体情况</td>
      <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;" colspan="2" rowspan="1">大中型水库</td>
      <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;" colspan="2" rowspan="1">小(一)型水库</td>
      <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;" colspan="2" rowspan="1">小(二)型水库</td>
      </tr>
      <tr style="background: #b0c0d5;">
      <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">总蓄水量</td>
      <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">总蓄水率</td>
      <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">还可拦蓄总量</td>
      <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">还可调用总量</td>
      <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">蓄水量</td>
      <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">蓄水率</td>
      <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">蓄水量</td>
      <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">蓄水率</td>
      <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">蓄水量</td>
      <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 14pt; border: 1px solid #ccc;">蓄水率</td>
      </tr>
      ${this.reservoirListFrame}
      </tbody>
      </table>
      <p style="padding: 8px; font-weight: 500; margin-top: 30px; font-size: 16pt;">4.下一步建议</p>
      ${this.nextTextFrame}    
    `
    },
    tabledata () {
      this.loading = true
      this.$store
        .dispatch(reportAnalysisTypes.WATER_RAIN_DAILY, {
          Time: this.query.begTime
        })
        .then(data => {
          this.nextText = data.data.nextText
          this.rainInfo = data.data.rainInfo
          this.riverInfo = data.data.riverInfo
          this.townList = data.data.townList
          this.reservoirInfo = data.data.reservoirInfo
          this.reservoirList = data.data.reservoirList
          // 各镇降雨量表格拼接
          this.townList.slice(0, 10).forEach(el => { // 截取表格前10个
            this.townListFrame11 += `
              <td style="word-break: break-all; text-align: center; vertical-align: middle; width: 105px; font-size: 14pt; border: 1px solid #ccc;">${el.townName}</td>
            `
            this.townListFrame12 += `
              <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${el.value}</td>
            `
            this.townListFrame13 += `
              <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${el.stationInfo}</td>
            `
          })
          this.townList.slice(10, 20).forEach(el => { // 截取表格前10-20个
            this.townListFrame21 += `
              <td style="word-break: break-all; text-align: center; vertical-align: middle; width: 105px; font-size: 14pt; border: 1px solid #ccc;">${el.townName}</td>
            `
            this.townListFrame22 += `
              <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${el.value}</td>
            `
            this.townListFrame23 += `
              <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${el.stationInfo}</td>
            `
          })
          this.townList.slice(20, 30).forEach(el => { // 截取表格前20-30个
            this.townListFrame31 += `
              <td style="word-break: break-all; text-align: center; vertical-align: middle; width: 105px; font-size: 14pt; border: 1px solid #ccc;">${el.townName === undefined ? '-' : el.townName}</td>
            `
            this.townListFrame32 += `
              <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${el.value}</td>
            `
            this.townListFrame33 += `
              <td style="word-break: break-all; text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${el.stationInfo}</td>
            `
          })
          this.nextText.forEach(el => {
            this.nextTextFrame += `  <p style="font-size: 14pt; margin-top: -5px; text-indent: 25px;">${el}</p>`
          })
          this.reservoirInfo.forEach(el => {
            this.reservoirInfoFrame += ` <p style="font-size: 14pt; margin-top: -5px; text-indent: 25px;">${el}</p>`
          })
          this.reservoirList.forEach(el => {
            this.reservoirListFrame += ` <tr>
            <td style="text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${el.typeName === undefined ? '--' : el.typeName}</td>
            <td style="text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${el.totalImpoundment === undefined ? '--' : el.totalImpoundment}</td>
            <td style="text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${el.totalImpoundmentRate === undefined ? '--' : el.totalImpoundmentRate}</td>
            <td style="text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${el.totalRetain === undefined ? '--' : el.totalRetain}</td>
            <td style="text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${el.totalInvoking === undefined ? '--' : el.totalInvoking}</td>
            <td style="text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${el.bigImpoundment === undefined ? '--' : el.bigImpoundment}</td>
            <td style="text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${el.bigRate === undefined ? '--' : el.bigRate}</td>
            <td style="text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${el.smallOneImpoundment === undefined ? '--' : el.smallOneImpoundment}</td>
            <td style="text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${el.smallOneRate === undefined ? '--' : el.smallOneRate}</td>
            <td style="text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${el.smallTwoImpoundment === undefined ? '--' : el.smallTwoImpoundment}</td>
            <td style="text-align: center; vertical-align: middle; font-size: 12pt; border: 1px solid #ccc;">${el.smallTwoRate === undefined ? '--' : el.smallTwoRate}</td>
            </tr>`
          })
          this.loading = false
          this.getShowDataTr()
        })
    },
    // 转换图片为 base64 (todo: 有可能因跨域报错)
    convertImagesToBase64 (contentDocument) {
      // 找到所有的图片
      let imgs = contentDocument.querySelectorAll('img')
      // 图片转换用
      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')
      imgs.forEach((img, i) => {
        if (img.src.startsWith('data:image')) return
        // img表现尺寸
        let realWidth = parseInt(img.style.width)
        let realHeight = parseInt(img.style.height)

        // 清空画布并调整为 img 的大小
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        canvas.width = realWidth
        canvas.height = realHeight
        // 画图片到画布
        ctx.drawImage(
          img,
          0,
          0,
          img.width,
          img.height,
          0,
          0,
          realWidth,
          realHeight
        )
        // ctx.drawImage(img, 0, 0);

        // 画布转为 base64
        let dataURL = canvas.toDataURL()
        img.setAttribute('src', dataURL)
      })

      canvas.remove()
    },
    convertChartsToBase64 (contentDocument) {
      // 找到所有的图表 （echart）
      let canvases = contentDocument.querySelectorAll('canvas')
      // 遍历图表，转换为 base64 静态图片
      canvases.forEach((canvas, i) => {
        let echart = this.$refs.chart[i]
        let url = echart.getDataURL()
        let img = document.createElement('img')
        img.src = url
        canvas.parentNode.replaceChild(img, canvas)
      })
    },
    // 生成下载链接
    createDownloadLink (fileObj, fileName) {
      let link = document.createElement('a')
      link.href = URL.createObjectURL(fileObj)
      link.download = fileName || 'document.docx'
      link.appendChild(document.createTextNode(''))
      return link
    },
    exportDocx () {
      // 获取页面dom元素
      let contentDocument = this.tinymceHtml
      let content = `<!DOCTYPE html>
            <head>
                <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
                 <style>
                 <style>
            </head>
            <body>
                ${contentDocument}
            </body>
            </html>`
      let converted = htmlDocx.asBlob(content)
      saveAs(converted, '水雨情日报.docx')
      let link = this.createDownloadLink(converted, '水雨情日报.docx')
      this.$refs.downloadArea.innerHTML = ''
      this.$refs.downloadArea.appendChild(link)
    }
  },
  created () {
    // let now = new Date()
    // this.query.begTime = this.Global.timeFormat(now)
    // console.log(this.query.begTime)
    this.getCurrentTime()
    let myDate = new Date()
    this.currentYear = myDate.getFullYear()
    this.titleTime = myDate.getFullYear() + '年' + (myDate.getMonth() + 1) + '月' + myDate.getDate() + '日'
    this.showTime = (myDate.getMonth() + 1) + '月' + myDate.getDate() + '日' + myDate.getHours() + ':' + (myDate.getMinutes() > 9 ? myDate.getMinutes() : '0' + myDate.getMinutes())
  },
  mounted () {
    tinymce.init({})
    this.tabledata()
    this.$nextTick(() => {
      let contentDiv = document.getElementsByClassName('content')
      this.$refs['yuliang'].style.height =
        contentDiv[0].offsetHeight - 30 + 'px'
      let selectHeight = this.$refs.districtrainOperation.offsetHeight
      this.$refs.tableDiv.style.height = this.$refs.yuliang.offsetHeight - selectHeight - 30 + 'px'
    })
  }
}
</script>
<style lang="less" src="@/assets/monitor.less" scoped>
</style>
<style lang="less" scoped>
.yuliang {
   /deep/ .tableDiv{
      margin-top: 15Px;
      width:98%;
      margin-left: 1%;
      overflow: auto;
      padding-top: 10px;
    }
}
</style>
